export const metadataNameHackIn = (name: string) => {
	// assetId -> objectId ¯\_(ツ)_/¯
	if (name === 'objectId') return 'assetId';
	return name;
};

export default metadataNameHackIn;
